'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _parseFloat = require('babel-runtime/core-js/number/parse-float');

var _parseFloat2 = _interopRequireDefault(_parseFloat);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EventPrice = function (_Component) {
  (0, _inherits3.default)(EventPrice, _Component);

  function EventPrice() {
    (0, _classCallCheck3.default)(this, EventPrice);
    return (0, _possibleConstructorReturn3.default)(this, (EventPrice.__proto__ || (0, _getPrototypeOf2.default)(EventPrice)).apply(this, arguments));
  }

  (0, _createClass3.default)(EventPrice, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          currency = _props.currency,
          notes = _props.notes,
          type = _props.type,
          prices = _props.prices;

      var typeLabels = {
        FREE: 'Gratuit',
        DONATION: 'Contribution volontaire'
      };
      var sortedPrices = prices.slice().sort(function (a, b) {
        return (0, _parseFloat2.default)(a.value) - (0, _parseFloat2.default)(b.value);
      });

      if (type === 'FIXED' && prices.length === 0) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: 'EventPrice' },
        typeLabels[type] && _react2.default.createElement(
          'span',
          { className: 'label' },
          typeLabels[type]
        ),
        type !== 'FREE' && prices.length > 0 && _react2.default.createElement(
          'ul',
          { className: 'prices' },
          sortedPrices.map(function (price, index) {
            return _react2.default.createElement(
              'li',
              { key: index },
              _react2.default.createElement(
                'strong',
                null,
                price.value,
                ' $',
                currency
              ),
              ' \u2013 ',
              price.description
            );
          })
        ),
        notes && _react2.default.createElement(
          'p',
          { className: 'notes' },
          notes
        )
      );
    }
  }]);
  return EventPrice;
}(_react.Component);

EventPrice.propTypes = {
  /**
   * Three-letter currency code.
   */
  currency: _propTypes2.default.string,
  /**
   * Notes about the price.
   */
  notes: _propTypes2.default.string,
  /**
   * Price type: free, fixed, or PWYC.
   */
  type: _propTypes2.default.oneOf(['FREE', 'FIXED', 'DONATION']).isRequired,
  /**
   * List of prices.
   */
  prices: _propTypes2.default.arrayOf(_propTypes2.default.object)
};
EventPrice.defaultProps = {
  prices: []
};
exports.default = EventPrice;


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/components/EventPrice.js
// module id = 273
// module chunks = 0